module.exports = __webpack_public_path__ + "media/src/images/top_covers/April_02-522ed4441da456814d7c62cee9fa1710.png";